import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { Observable } from 'rxjs';

import { TranslateService } from '@codeandweb/ngx-translate';

import { Table, TableModule } from '@app/primeng-overrides/table';
import { LazyLoadEvent } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToolbarModule } from 'primeng/toolbar';

import { GlobalModule } from '@app/_global/global.module';
import { SiteService } from '@app/site/site.service';
import { EventManagerService, IEventListener } from '@global/event-manager.service';
import { AbonneService } from '@app/abonne/abonne.service';
import { SiteSelectorModule } from '@app/site/site-selector';

import { createDownloadFromHttpResponse, uid } from '@helpers/utils';
import { environment } from '@environments/environment';

@Component({
	selector: 'historique-conformite-texte-dialog',
	templateUrl: './historique-conformite-texte-dialog.html',
	providers: []
})
export class HistoriqueConformiteTexteDialogComponent implements OnInit, IEventListener {

	private _uuid: string = uid();
	get uuid(): string { return this._uuid; }

	abo_id: number;
	txt_id: number;
	etapeConformite: 'evaluations' | 'recolements';
	isMonoSite: boolean;

	@ViewChild('tableHistorique', { static: true }) table: Table;

	values: any[] = [];
	totalRecords: number = 0;
	loading: boolean;
	exportLoading: boolean = false;
	rows: number = environment.default_rows;

	sit_ids: number[] = [];
	sit_id: number | null = null;

	constructor(
		private dialogRef: DynamicDialogRef,
		private config: DynamicDialogConfig,
		private eventManager: EventManagerService,
		private translateService: TranslateService,
		private abonneService: AbonneService,
		private siteService: SiteService,
	) {
		this.etapeConformite = config.data.etapeConformite;
		this.txt_id = config.data.txt_id;
		this.sit_ids = config.data.sit_ids;
		this.abo_id = abonneService.currentAbonneValue!.abo_id;

		this.isMonoSite = abonneService.currentAbonneValue!.sites.length == 1;
	}

	ngOnInit(): void {
		this.eventManager.registerEvent('close-modals', this, (args: any) => this.dialogRef.close());
	}

	ngOnDestroy(): void {
		this.eventManager.unregisterEvent('close-modals', this);
	}

	loadHistorique(event: LazyLoadEvent) {
		// https://github.com/primefaces/primeng/issues/8465#issuecomment-617887919
		Promise.resolve(null).then(() => {
			this.loading = true;
		});

		let sit_ids: string | number;
		if (this.sit_id) {
			sit_ids = this.sit_id;
		}
		else {
			sit_ids = this.sit_ids.join(',');
		}

		const tmpParams = Object.assign({}, event, {sit_ids: sit_ids});

		this.siteService.getHistoriqueEvaluationsTexte(this.abo_id, this.txt_id, tmpParams)
		.subscribe({
			next: ({ total, historique }) => {
				this.totalRecords = total;
				this.values = historique;

				// si on revient sur la liste paginée et que la page en question est vide, on reset
				if (this.values.length === 0 && this.table.first != 0) {
					this.refresh();
				}
			}
		})
		.add(() => {
			this.loading = false;
		});
	}

	refresh(stayOnPage?: boolean) {
		if (!stayOnPage) this.table._first = 0;
		this.table.onLazyLoad.emit(this.table.createLazyLoadMetadata());
	}

	exporterHistorique() {
		this.exportLoading = true;

		let sit_ids: string | number;
		if (this.sit_id) {
			sit_ids = this.sit_id;
		}
		else {
			sit_ids = this.sit_ids.join(',');
		}


		this.siteService.exportHistoriqueEvaluationsTexte(this.abo_id, this.txt_id, {sit_ids: sit_ids})
		.subscribe(response => {
			createDownloadFromHttpResponse(response);
		})
		.add(() => {
			this.exportLoading = false;
		});
	}
}


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		GlobalModule,
		ButtonModule,
		InputTextareaModule,
		TableModule,
		ToolbarModule,
		SiteSelectorModule
	],
	exports: [HistoriqueConformiteTexteDialogComponent],
	declarations: [HistoriqueConformiteTexteDialogComponent]
})
export class HistoriqueConformiteTexteDialogModule { }

